// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("./SolarPanels.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Poppins:ital,wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;0,800;0,900;1,100;1,200;1,300;1,400;1,500;1,600;1,700;1,800;1,900&display=swap);"]);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `html, body
{
    height: 100%;
    margin:0;
    padding:0;
    scroll-behavior: smooth;
}

/* .App{
  position: absolute;
  top:0;
  left: 0;
  width: 100%;
  height: 150%;
  z-index: 10;
  background-image: url("./SolarPanels.png");
} */

.light-text{
  color: #F6F1F1 ;
}

html *{
  font-family: "Poppins", sans-serif !important;
}

a{
  text-decoration: none;
}

#heading{
  font-size: 4rem;
}

.flex-container{
  display: flex;
  gap: 100px;
}

#intro-div{
  width: 100%;
  height: auto;
  background-size: cover;
  background-repeat: no-repeat;
  object-fit: contain;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  margin-left: auto;
  margin-right: auto;
  padding-top: 10%;
  padding-left: 2rem;
  padding-right: 2rem;
  padding-bottom: 10%;
  border-bottom-left-radius: 1500px 200px;
  border-bottom-right-radius: 1500px 200px;
}

#background-intro{
  background-color: #AFD3E2 ;
}

#form-div{
  margin-top: 0;
  padding-bottom: 8%;
  background-color: #AFD3E2 ;
  height:auto;
  width: 100%;
}


#form-heading{
  margin: 0 auto ;
  text-align: center ;
  padding: 2%  0 1% 0;
}


#form-grid{
  display: grid;
  grid-template-columns: 1fr 1fr;
  grid-template-rows: auto;
  gap: 10px;
}

#form-container{
  padding: 0 10%;
}

#complete-msg-div{
  margin: 2% auto ;
  text-align: center ;
  padding: 2%  0 1% 0;
}


#form-submit{
  grid-column: span 2;
  margin: 1% 0;
}

#benefits-flex{
  background-color: #F6F1F1;
  text-align: center;
  height: auto;
  width: 100%;
  padding: 2% 10%;
}




#accordion-div{
  width: 100%;
  border-radius: 40px 40px 40px 40px;
  overflow: hidden;
  box-shadow: 5px 5px 5px 5px rgba(0, 0, 0, 0.3);
}

#benefits h2{
  margin: 0 0 3% 1% ;
  padding-top: 2rem;
  color: '#146C94';
  font-size: 2rem;
}

#benefits{
  border-top: 2px solid #146C94;
}

#about-div{
  margin-top: 20px;
}

.process-step {
  display: grid;
  grid-template-columns: 1fr 0.2fr;
  color: #555554;
}


footer{
  width: 100%;
  height: auto;
  background-color: #146C94;
  color: #F6F1F1;
  padding: 2% 2%;
  overflow: hidden;
  
}

#links-footer{
  justify-content: right;
  margin-right: 5%;
}

#links-footer a{
  display: block;
  text-decoration: underline;
  color: #F6F1F1;
}

#email-span{
  text-decoration: underline;
}

#process-flex{
  display: grid;
  grid-template-columns: repeat(6, 1fr);
  gap: 10px;
}

#ff-img{
  height: 7rem;
}

#copyright-div  *{
  display: inline;
}

.left-element{
  display: inline-block;
  float: left;
  margin-right: 5%;
}

.right-element{
  display: inline-block;
  float: right;
}

#social-div{
  margin-top: 20px;
}
#social-div a{
  display: inline;
  margin-right: 10px;
  color: #F6F1F1;
}

.transparent{
  background: transparent;
  box-shadow: none; 
}

.nav{
  background-color: black;
  transition: 0.3s ease-in-out;
}

@media screen and  (max-width: 1100px) {
  .flex-container{
    flex-direction: column;
    gap: 25px;
  }
}

@media screen and  (max-width: 900px) {
    #heading{
    font-size: 2rem;
    text-align: center;
  }  

  #process-flex{
    grid-template-columns: repeat(2, 1fr);
  }
}

@media screen and  (max-width: 768px) {
  #intro-div{
    padding-top: 20%;
  }
  #form-grid{
    grid-template-columns: 1fr ;
    grid-template-rows: auto;
    gap: 10px;
  }  

  #form-submit{
    grid-column: span 1;
  }
  #benefits h2{
    margin: 0 0 6% 1% ;
    padding-top: 2rem;
    color: '#146C94';
    font-size: 1.5rem;
  
  }

  .right-element{
    float: left;
  }
}

`, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":"AACA;;IAEI,YAAY;IACZ,QAAQ;IACR,SAAS;IACT,uBAAuB;AAC3B;;AAEA;;;;;;;;GAQG;;AAEH;EACE,eAAe;AACjB;;AAEA;EACE,6CAA6C;AAC/C;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,UAAU;AACZ;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,sBAAsB;EACtB,4BAA4B;EAC5B,mBAAmB;EACnB,yDAA0C;EAC1C,iBAAiB;EACjB,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;EACnB,mBAAmB;EACnB,uCAAuC;EACvC,wCAAwC;AAC1C;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,aAAa;EACb,kBAAkB;EAClB,0BAA0B;EAC1B,WAAW;EACX,WAAW;AACb;;;AAGA;EACE,eAAe;EACf,mBAAmB;EACnB,mBAAmB;AACrB;;;AAGA;EACE,aAAa;EACb,8BAA8B;EAC9B,wBAAwB;EACxB,SAAS;AACX;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,mBAAmB;AACrB;;;AAGA;EACE,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,YAAY;EACZ,WAAW;EACX,eAAe;AACjB;;;;;AAKA;EACE,WAAW;EACX,kCAAkC;EAClC,gBAAgB;EAChB,8CAA8C;AAChD;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,gCAAgC;EAChC,cAAc;AAChB;;;AAGA;EACE,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,cAAc;EACd,cAAc;EACd,gBAAgB;;AAElB;;AAEA;EACE,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,0BAA0B;EAC1B,cAAc;AAChB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,aAAa;EACb,qCAAqC;EACrC,SAAS;AACX;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,qBAAqB;EACrB,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;EACrB,YAAY;AACd;;AAEA;EACE,gBAAgB;AAClB;AACA;EACE,eAAe;EACf,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA;EACE,uBAAuB;EACvB,4BAA4B;AAC9B;;AAEA;EACE;IACE,sBAAsB;IACtB,SAAS;EACX;AACF;;AAEA;IACI;IACA,eAAe;IACf,kBAAkB;EACpB;;EAEA;IACE,qCAAqC;EACvC;AACF;;AAEA;EACE;IACE,gBAAgB;EAClB;EACA;IACE,2BAA2B;IAC3B,wBAAwB;IACxB,SAAS;EACX;;EAEA;IACE,mBAAmB;EACrB;EACA;IACE,kBAAkB;IAClB,iBAAiB;IACjB,gBAAgB;IAChB,iBAAiB;;EAEnB;;EAEA;IACE,WAAW;EACb;AACF","sourcesContent":["@import url('https://fonts.googleapis.com/css2?family=Poppins:ital,wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;0,800;0,900;1,100;1,200;1,300;1,400;1,500;1,600;1,700;1,800;1,900&display=swap');\nhtml, body\n{\n    height: 100%;\n    margin:0;\n    padding:0;\n    scroll-behavior: smooth;\n}\n\n/* .App{\n  position: absolute;\n  top:0;\n  left: 0;\n  width: 100%;\n  height: 150%;\n  z-index: 10;\n  background-image: url(\"./SolarPanels.png\");\n} */\n\n.light-text{\n  color: #F6F1F1 ;\n}\n\nhtml *{\n  font-family: \"Poppins\", sans-serif !important;\n}\n\na{\n  text-decoration: none;\n}\n\n#heading{\n  font-size: 4rem;\n}\n\n.flex-container{\n  display: flex;\n  gap: 100px;\n}\n\n#intro-div{\n  width: 100%;\n  height: auto;\n  background-size: cover;\n  background-repeat: no-repeat;\n  object-fit: contain;\n  background-image: url(\"./SolarPanels.png\");\n  margin-left: auto;\n  margin-right: auto;\n  padding-top: 10%;\n  padding-left: 2rem;\n  padding-right: 2rem;\n  padding-bottom: 10%;\n  border-bottom-left-radius: 1500px 200px;\n  border-bottom-right-radius: 1500px 200px;\n}\n\n#background-intro{\n  background-color: #AFD3E2 ;\n}\n\n#form-div{\n  margin-top: 0;\n  padding-bottom: 8%;\n  background-color: #AFD3E2 ;\n  height:auto;\n  width: 100%;\n}\n\n\n#form-heading{\n  margin: 0 auto ;\n  text-align: center ;\n  padding: 2%  0 1% 0;\n}\n\n\n#form-grid{\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  grid-template-rows: auto;\n  gap: 10px;\n}\n\n#form-container{\n  padding: 0 10%;\n}\n\n#complete-msg-div{\n  margin: 2% auto ;\n  text-align: center ;\n  padding: 2%  0 1% 0;\n}\n\n\n#form-submit{\n  grid-column: span 2;\n  margin: 1% 0;\n}\n\n#benefits-flex{\n  background-color: #F6F1F1;\n  text-align: center;\n  height: auto;\n  width: 100%;\n  padding: 2% 10%;\n}\n\n\n\n\n#accordion-div{\n  width: 100%;\n  border-radius: 40px 40px 40px 40px;\n  overflow: hidden;\n  box-shadow: 5px 5px 5px 5px rgba(0, 0, 0, 0.3);\n}\n\n#benefits h2{\n  margin: 0 0 3% 1% ;\n  padding-top: 2rem;\n  color: '#146C94';\n  font-size: 2rem;\n}\n\n#benefits{\n  border-top: 2px solid #146C94;\n}\n\n#about-div{\n  margin-top: 20px;\n}\n\n.process-step {\n  display: grid;\n  grid-template-columns: 1fr 0.2fr;\n  color: #555554;\n}\n\n\nfooter{\n  width: 100%;\n  height: auto;\n  background-color: #146C94;\n  color: #F6F1F1;\n  padding: 2% 2%;\n  overflow: hidden;\n  \n}\n\n#links-footer{\n  justify-content: right;\n  margin-right: 5%;\n}\n\n#links-footer a{\n  display: block;\n  text-decoration: underline;\n  color: #F6F1F1;\n}\n\n#email-span{\n  text-decoration: underline;\n}\n\n#process-flex{\n  display: grid;\n  grid-template-columns: repeat(6, 1fr);\n  gap: 10px;\n}\n\n#ff-img{\n  height: 7rem;\n}\n\n#copyright-div  *{\n  display: inline;\n}\n\n.left-element{\n  display: inline-block;\n  float: left;\n  margin-right: 5%;\n}\n\n.right-element{\n  display: inline-block;\n  float: right;\n}\n\n#social-div{\n  margin-top: 20px;\n}\n#social-div a{\n  display: inline;\n  margin-right: 10px;\n  color: #F6F1F1;\n}\n\n.transparent{\n  background: transparent;\n  box-shadow: none; \n}\n\n.nav{\n  background-color: black;\n  transition: 0.3s ease-in-out;\n}\n\n@media screen and  (max-width: 1100px) {\n  .flex-container{\n    flex-direction: column;\n    gap: 25px;\n  }\n}\n\n@media screen and  (max-width: 900px) {\n    #heading{\n    font-size: 2rem;\n    text-align: center;\n  }  \n\n  #process-flex{\n    grid-template-columns: repeat(2, 1fr);\n  }\n}\n\n@media screen and  (max-width: 768px) {\n  #intro-div{\n    padding-top: 20%;\n  }\n  #form-grid{\n    grid-template-columns: 1fr ;\n    grid-template-rows: auto;\n    gap: 10px;\n  }  \n\n  #form-submit{\n    grid-column: span 1;\n  }\n  #benefits h2{\n    margin: 0 0 6% 1% ;\n    padding-top: 2rem;\n    color: '#146C94';\n    font-size: 1.5rem;\n  \n  }\n\n  .right-element{\n    float: left;\n  }\n}\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
